/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {rosterMdsGetAuditLogs} from '../api'

export const useMutationRosterMdsGetAuditLogs = createReactQueryMutationHook('rosterMdsGetAuditLogs', rosterMdsGetAuditLogs)
